import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import Dashboard from '../pages/admintbk/Dashboard'
import { Logout } from '../modules/auth'
import KategoriProduk from '../pages/admintbk/KategorProduk'
import Transaksi from '../pages/admintbk/Transaksi'
import RekapshitKasir from '../pages/admintbk/rekapShiftKasir'
import DataSupplier from '../pages/admintbk/DataSupplier'
import DataKasir from '../pages/admintbk/DataKasir'
import LaporanHarian from '../pages/admintbk/LaporanHarian'
import LaporanKeuanga from '../pages/admintbk/LaporanKeuanga'
import LaporanStok from '../pages/admintbk/LaporanStok'
import LaporanProduk from '../pages/admintbk/LaporanProduk'
import AllProduk from '../pages/admintbk/AllProduk'
import StokProduk from '../pages/admintbk/StokProduk'
import LaporanPenjualan from '../pages/admintbk/LaporanPenjualan'
import ManagementAAccount from '../pages/admintbk/ManagementAcccount'
import Suppliear from '../pages/admintbk/Supplier'
import HistoryPage from '../modules/admintbk/component/HistoryPage'
import ReturnPage from '../modules/admintbk/ReturnPage'



const Adminroute = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        {/* <Route path='dashboard' element={<DashboardWrapper />} /> */}
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* cassier */}
        <Route path='dashboard' element={<Dashboard />} />
        <Route path='dataatransaksi' element={<Transaksi />} />
        <Route path='laporanpenjualan' element={<LaporanPenjualan />} />
        <Route path='StokProduk' element={<StokProduk />} />
        <Route path='kategoriproduk' element={<KategoriProduk />} />
        <Route path='allproduk' element={<AllProduk />} />
        <Route path='lapornProduk' element={<LaporanProduk />} />
        <Route path='laporanstok' element={<LaporanStok />} />
        <Route path='laporankeuangaan' element={<LaporanKeuanga />} />
        <Route path='laporanharian' element={<LaporanHarian />} />
        <Route path='datakasir' element={<DataKasir />} />
        <Route path='supplier' element={<Suppliear />} />
        <Route path='permintaanreturn' element={<ReturnPage />} />
        <Route path='management' element={<ManagementAAccount />} />
        <Route path='StokProduk/history' element={<HistoryPage />} />


        <Route path='logout' element={<Logout />} /> {/* Added this line */}

        {/* Lazy Modules */}

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { Adminroute }
